import gql from 'graphql-tag'

import * as USER from "./mutations/User.js";

export { USER };

/*------------- LOGIN ------------*/
export const USER_LOGIN = gql `
  mutation usuarioLoginToken(
    $login: String!
    $tipo_login: String!
    $password: String!
    $plataforma: String!
    $tipo_web: String!
  ) {
    usuarioLoginToken(
      login: $login
      tipo_login: $tipo_login
      password: $password
      plataforma: $plataforma
      tipo_web: $tipo_web
    ) {
      user_token
      access_token
      refresh_token
    }
  }
`;
/*------------- LOGIN ------------*/
/*------------- PASSWORD RECOVERY ------------*/
export const CHECK_TOKEN_RECOVERY = gql `
  mutation checkTokenRecovery($token: String!, $uuid: String!) {
    checkTokenRecuperar(token: $token, uuid: $uuid) {
      id_usuario
      token
    }
  }
`;

export const RECOVER_PASS = gql `
  mutation recuperarPassword($correo: String!) {
    recuperarPassword(correo: $correo) {
      token
      uuid
      action
    }
  }
`;

export const VERIFY_PASSWORD = gql `
  mutation checkCurrentPasswordBoolean($id_usuario: String!, $password: String!) {
    checkCurrentPasswordBoolean(id_usuario: $id_usuario, password: $password) {
      id_usuario
      password
    }
  }
`;


export const EDIT_PASSWORD = gql `
  mutation editPasswordUsuarioUpdate($id_usuario: String!, $password: String!) {
    editPasswordUsuarioUpdate(id_usuario: $id_usuario, password: $password) {
      id_usuario
      password
    }
  }
`;
export const EDIT_PASSWORD_RECUPERACION = gql`
  mutation editPasswordRecuperacion
    (
      $id_usuario: String!, $password: String!, $token: String!, $uuid: String!
    ) 
  {
  editPasswordRecuperacion(id_usuario:$id_usuario, password:$password, token:$token, uuid:$uuid)
    {
      id_usuario
      password
    }
}`;

// MURO
export const CREAR_POST_MURO = gql `
mutation crearMuro(
  $imagen_muro: String! 
  $imagen_formato: String!
  $texto: String!
  $id_usuario: String!
  $id_empresa: String!
  ) 
  {
  crearMuro(
    id_usuario: $id_usuario,
    imagen_muro: $imagen_muro,
    imagen_formato: $imagen_formato,
    video_muro: "",
    video_formato: "",
    id_empresa: $id_empresa,
    texto: $texto
  ) 
  {
    id_muro
    texto
    imagen_muro
    video_muro
    fecha_creacion
    usuario {
      id_usuario
      primer_nombre
      apellido_paterno
      imagen_perfil
    }
    likes {
      id_like
      id_usuario_fk
    }
    confirm_like {
      id_like
    }
    likes_global {
      id_like
      usuario {
        id_usuario
        primer_nombre
        apellido_paterno
        imagen_perfil
        cargo {
          nombre_cargo
        }
      }
    }
    confirm_like_global {
      id_like
      fecha_creacion
      is_team
      usuario {
        id_usuario
        primer_nombre
        segundo_nombre
        apellido_paterno
        apellido_materno
        rut_usuario
      }
    }
    comentarios {
      id_comentario
      texto
      usuario {
        id_usuario
        primer_nombre
        apellido_paterno
        imagen_perfil
      }
      likes {
        id_like
        id_usuario_fk
      }
    }
  }
}
`
export const CREAR_COMENTARIOS_MURO = gql `
mutation enviarComentarioMuro(
  $id_muro: String! 
  $texto: String!
  $id_usuario: String!
  $id_empresa: String!
  ) 
  {
  enviarComentarioMuro(
    id_usuario: $id_usuario,
    id_muro: $id_muro,
    id_empresa: $id_empresa,
    texto: $texto,
    menciones: ""
  ) {
    id_muro,
    comentarios 
    {
      id_comentario
      texto
      usuario {
        id_usuario
        primer_nombre
        apellido_paterno
        imagen_perfil
      }
      likes {
        id_like
        id_usuario_fk
      }
    }
  }
}`;
export const EDITAR_COMENTARIOS_MURO = gql `
mutation editarComentarioMuro(
  $id_comentario: String!, 
  $texto: String! 
  $id_muro: String!
  $id_usuario: String!
  $id_empresa: String!
  ) 
  {
  editarComentarioMuro(
    id_usuario: $id_usuario,
    id_comentario: $id_comentario,
    id_empresa: $id_empresa,
    texto: $texto,
    id_muro: $id_muro,
    menciones: ""
  ) {
    id_muro
    comentarios 
    {
      id_comentario
      texto
      usuario {
        id_usuario
        primer_nombre
        apellido_paterno
        imagen_perfil
      }
      likes {
        id_like
        id_usuario_fk
      }
    }
  }
}`;
export const DAR_LIKE_COMENTARIO_MURO = gql `
mutation darLikeMuroComentario(
  $id_comentario: String! 
  $id_muro: String!
  $id_empresa: String!
  $id_usuario: String!

  ) 
  {
  darLikeMuroComentario(id_usuario: $id_usuario, id_empresa: $id_empresa, id_comentario: $id_comentario, id_muro: $id_muro) 
  {
    id_muro
    comentarios {
      id_comentario
      texto
      usuario {
        id_usuario
        primer_nombre
        apellido_paterno
        imagen_perfil
        cargo {
          nombre_cargo
        }
      }
      menciones {
        id_mencion
      }
      likes {
        id_like
        usuario {
          id_usuario
          primer_nombre
          apellido_paterno
          imagen_perfil
          cargo {
            nombre_cargo
          }
        }
      }
    }
  }
}`;
export const QUITAR_LIKE_COMENTARIOS_MURO = gql `
mutation quitarLikeMuroComentario(
  $id_comentario: String!
  $id_muro: String! 
  $id_empresa: String!
  $id_usuario: String!
  ) 
  {
  quitarLikeMuroComentario(id_usuario: $id_usuario, id_empresa: $id_empresa, id_comentario: $id_comentario, id_muro: $id_muro) 
  {
    id_muro
    comentarios {
      id_comentario
      texto
      usuario {
        id_usuario
        primer_nombre
        apellido_paterno
        imagen_perfil
        cargo {
          nombre_cargo
        }
      }
      menciones {
        id_mencion
      }
      likes {
        id_like
        usuario {
          id_usuario
          primer_nombre
          apellido_paterno
          imagen_perfil
          cargo {
            nombre_cargo
          }
        }
      }
    }
  }
}`;

export const EDITA_POST = gql `
mutation editarMuro(
  $imagen_muro: String!
  $imagen_formato: String!
  $texto: String!
  $id_muro: String!
  $id_usuario: String!
  $id_empresa: String!
) 
{
  editarMuro(
    id_usuario: $id_usuario,
    imagen_muro: $imagen_muro,
    imagen_formato: $imagen_formato,
    video_muro: "",
    video_formato: "",
    id_empresa: $id_empresa,
    texto: $texto,
    id_muro: $id_muro
  ) 
  {
    id_muro
    texto
    imagen_muro
    video_muro
    fecha_creacion
    usuario {
      id_usuario
      primer_nombre
      apellido_paterno
      imagen_perfil
    }
    likes {
      id_like
      id_usuario_fk
    }
    comentarios 
    {
      id_comentario
      texto
      usuario {
        id_usuario
        primer_nombre
        apellido_paterno
        imagen_perfil
      }
      likes {
        id_like
        id_usuario_fk
      }
    }
  }
}`;
export const ELIMINAR_POST = gql `
mutation eliminarMuro(
  $id_muro: String!
  $id_usuario: String!
  $id_empresa: String!
  ) 
  {
  eliminarMuro(id_usuario: $id_usuario, id_empresa: $id_empresa, id_muro: $id_muro) 
  {
    id_muro
  }
}`;
export const ELIMINAR_COMENTARIOS_POST = gql `
mutation eliminarComentarioMuro(
  $id_comentario: String! 
  $id_muro: String!
  $id_usuario: String!
  $id_empresa: String!
  ) 
  {
  eliminarComentarioMuro(id_usuario: $id_usuario, id_comentario: $id_comentario, id_empresa: $id_empresa, id_muro: $id_muro) 
  {
    id_muro
    comentarios 
    {
      id_comentario
      texto
      usuario {
        id_usuario
        primer_nombre
        apellido_paterno
        imagen_perfil
      }
      likes {
        id_like
        id_usuario_fk
      }
    }
  }
}`;
/*------------- HOME ------------*/
/*------------- NOTICIAS ------------*/
export const DAR_LIKE_NOTICIA = gql `
mutation darLikeNoticia(
  $id_noticia: String!
  $id_usuario: String!
  $id_empresa: String!
  ) 
  {
  darLikeNoticia(id_usuario: $id_usuario, id_empresa_fk: $id_empresa, id_noticia: $id_noticia) 
  {
    id_noticia
    likes {
      id_like
    }
    confirm_like {
      id_like
    }
  }
}`;

export const QUITAR_LIKE_NOTICIA = gql `
mutation quitarLikeNoticia(
  $id_noticia: String!
  $id_usuario: String!
  $id_empresa: String!
  $id_like: String!
  ) 
  {
  quitarLikeNoticia(id_usuario: $id_usuario, id_empresa_fk: $id_empresa, id_like: $id_like, id_noticia: $id_noticia) 
  {
    id_noticia
    likes {
      id_like
    }
    confirm_like {
      id_like
    }
  }
}
`;
/*------------- NOTICIAS ------------*/

/*------------- COMENTARIOS EMPRESA ------------*/
export const AGREGAR_COMENTARIO_EMPRESA = gql `
mutation agregarComentarioEmpresa(
  $id_usuario: String!
  $id_objeto: String!
  $id_modulo: String!
  $id_empresa: String!
  $texto: String!
  $id_comentario: String!
  $menciones: String!
  ) 
  {
    agregarComentarioEmpresa(
    id_usuario: $id_usuario,
    id_objeto: $id_objeto,
    id_modulo: $id_modulo,
    id_empresa: $id_empresa,
    texto: $texto,
    id_comentario: $id_comentario,
    menciones: $menciones
  ) 
  {
    id_comentario
    texto
    fecha_creacion
    usuario{
      id_usuario
      primer_nombre,
      apellido_paterno,
      imagen_perfil
    }
    respuestas_comentarios
    {
      id_comentario
      texto
      fecha_creacion
      usuario{
        id_usuario
        primer_nombre,
        apellido_paterno,
        imagen_perfil
      }
      likes{
        id_like
        usuario{
          id_usuario
        }
      }
    }
    likes{
      id_like
      usuario{
        id_usuario
      }
    }
  }
}`;

export const EDITAR_COMENTARIO_EMPRESA = gql `
mutation editarComentarioEmpresa(
  $id_usuario: String!
  $id_objeto: String!
  $id_modulo: String!
  $id_empresa: String!
  $texto: String!
  $id_comentario: String!
  $menciones: String!
  ) 
  {
    editarComentarioEmpresa(
    id_usuario: $id_usuario,
    id_objeto: $id_objeto,
    id_modulo: $id_modulo,
    id_empresa: $id_empresa,
    texto: $texto,
    id_comentario: $id_comentario,
    menciones: $menciones
  ) 
  {
    id_comentario
    texto
    fecha_creacion
    usuario{
      id_usuario
      primer_nombre,
      apellido_paterno,
      imagen_perfil
    }
    respuestas_comentarios
    {
      id_comentario
      texto
      fecha_creacion
      usuario{
        id_usuario
        primer_nombre,
        apellido_paterno,
        imagen_perfil
      }
      likes{
        id_like
        usuario{
          id_usuario
        }
      }
    }
    likes{
      id_like
      usuario{
        id_usuario
      }
    }
  }
}`;

export const ELIMINAR_COMENTARIO_EMPRESA = gql `
mutation eliminarComentarioEmpresa(
  $id_usuario: String!
  $id_objeto: String!
  $id_modulo: String!
  $id_empresa: String!
  $id_comentario: String!
  ) 
  {
    eliminarComentarioEmpresa(
      id_usuario: $id_usuario,
      id_objeto: $id_objeto,
      id_modulo: $id_modulo,
      id_empresa: $id_empresa,
      id_comentario: $id_comentario
    ) {
      id_comentario
    }
}`;

export const DAR_LIKE_COMENTARIO_EMPRESA = gql `
mutation darLikeComentarioEmpresa(
  $id_usuario: String!
  $id_empresa: String!
  $id_objeto: String!
  $id_comentario: String!
  $id_modulo: String!
  ) 
  {
    darLikeComentarioEmpresa(id_usuario: $id_usuario, id_empresa: $id_empresa, id_objeto: $id_objeto, id_comentario: $id_comentario, id_modulo: $id_modulo) {
    id_comentario
    likes {
      id_like,
      usuario {
        id_usuario
      }
    }
  }
}`;

export const QUITAR_LIKE_COMENTARIO_EMPRESA = gql `
mutation quitarLikeComentarioEmpresa(
  $id_usuario: String!
  $id_empresa: String!
  $id_objeto: String!
  $id_comentario: String!
  $id_modulo: String!
  $id_like: String!
  ) 
  {
    quitarLikeComentarioEmpresa(id_usuario: $id_usuario, id_empresa: $id_empresa, id_objeto: $id_objeto, id_comentario: $id_comentario, id_modulo: $id_modulo, id_like: $id_like) {
    id_comentario
    likes {
      id_like
      usuario {
        id_usuario
      }
    }
  }
}`;
//export const 
/*------------- COMENTARIOS EMPRESA ------------*/

/*-----GALERIA-----*/
export const DAR_LIKE_GALERIA = gql `
mutation darLikeImagen(
  $id_imagen: String! 
  $id_galeria: String!
  $id_empresa: String!
  $id_usuario: String!
  ) 
  {
  darLikeImagen(id_usuario: $id_usuario, id_empresa: $id_empresa, id_imagen: $id_imagen, id_galeria: $id_galeria) 
  {
    id_galeria
    imagenes
    {
      id_imagen
      url_imagen_original
      likes {
        id_like
        usuario {
          id_usuario
        }
      }
      confirm_like{
        id_like
      }
    }
  }
}`;

export const QUITAR_LIKE_GALERIA = gql `
mutation quitarLikeImagen(
  $id_imagen: String! 
  $id_galeria: String!
  $id_empresa: String!
  $id_usuario: String!
  ) 
  {
  quitarLikeImagen(id_usuario: $id_usuario, id_empresa: $id_empresa, id_imagen: $id_imagen, id_galeria: $id_galeria) 
  {
    id_galeria
    imagenes
    {
      id_imagen
      url_imagen_original
      likes {
        id_like
        usuario {
          id_usuario
        }
      }
      confirm_like{
        id_like
      }
    }
  }
}`;

/* LIKES */
export const DAR_LIKE = gql `
mutation agregarLikesEmpresa(
  $id_usuario: String!
  $id_empresa: String!
  $id_modulo: String!
  $id_objeto: String!
  $id_subobjeto: String!
  ) {
  agregarLikesEmpresa(
    id_usuario: $id_usuario
    id_empresa: $id_empresa
    id_modulo: $id_modulo
    id_objeto: $id_objeto
    id_subobjeto: $id_subobjeto
  ) {
    id_like
    fecha_creacion
    usuario {
      id_usuario
      primer_nombre
      apellido_paterno
      imagen_perfil
      cargo {
        nombre_cargo
      }
    }
  }
}`;

export const QUITAR_LIKE = gql `
mutation eliminarLikeEmpresa(
  $id_usuario: String!
  $id_empresa: String!
  $id_modulo: String!
  $id_objeto: String!
  $id_subobjeto: String!
  ) {
  eliminarLikeEmpresa(
    id_usuario: $id_usuario
    id_empresa: $id_empresa
    id_modulo: $id_modulo
    id_objeto: $id_objeto
    id_subobjeto: $id_subobjeto
  ) {
    id_like
    fecha_creacion
    usuario {
      id_usuario
      primer_nombre
      apellido_paterno
      imagen_perfil
      cargo {
        nombre_cargo
      }
    }
  }
}`;
/* --- LIKES */


export const RECONOCER = gql `
mutation reconocer(
  $id_reconocido: [String]!
  $id_reconocedor: String!
  $imagen: String!
  $formato: String!
  $comentario: String!
  $id_valor_comportamiento: String!
  $id_empresa: String!
  $id_relacion: String!
  $id_tipo: String!
  $id_superior: [String]!
  $nombre_grupo: String!

) {
  reconocer(
    id_reconocido: $id_reconocido,
    id_reconocedor: $id_reconocedor,
    imagen: $imagen,
    formato: $formato,
    comentario: $comentario,
    id_valor_comportamiento: $id_valor_comportamiento,
    id_empresa_fk: $id_empresa,
    id_relacion: $id_relacion,
    id_tipo: $id_tipo,
    id_superior: $id_superior,
    nombre_grupo: $nombre_grupo
  ) {
    id_reconocimiento
    fecha_creacion
    comentario_reconocimiento
    valor_comportamiento {
      id_valor_comportamiento
      valor {
        nombre_valor
        color
      }
    }
    tipo_reconocimiento {
      id_tipo
      nombre_tipo
    }
    likes {
      id_like
    }
    confirm_like {
      id_like
    }
    reconocedor {
      id_usuario
      primer_nombre
      apellido_paterno
      imagen_perfil
      cargo {
        nombre_cargo
      }
    }
    reconocidos {
      id_usuario
      primer_nombre
      apellido_paterno
      imagen_perfil
      cargo {
        nombre_cargo
      }
    }
    relacion {
      id_relacion
      nombre_relacion
    }
    url_imagen
  }
}
`
    /*----- RECONOCE -----*/

/*----- TRANSPORTE --- */
export const CREAR_INSCRIPCION_TRAMO = gql `
mutation SendSolicitudTransporte(
  $tramos: [crearSolicitudTransporte]!
  $id_empresa: String!
  $id_usuario: String!
) {
  SendSolicitudTransporte(
    tramos: $tramos,
    id_empresa: $id_empresa,
    id_usuario: $id_usuario
  ) {
    id_solicitud
  }
}`;

export const CANCELAR_INSCRIPCION_TRAMO = gql `
mutation cancelarSolicitud(
    $idSolicitud: [String]!
    $idEmpresa: String!
    $idUsuario: String!
  ) {
    cancelarSolicitud(
      id_solicitud: $idSolicitud,
      id_empresa: $idEmpresa,
      id_usuario: $idUsuario
  ) {
    id_solicitud
  }
}`;


/*----- TRANSPORTE --- */
/*----- ENCUESTA --- */
export const RESPONDER_ENCUESTA = gql `
mutation responderEncuesta(
  $respuestas: [RespuestasArr],
  $id_empresa: String!
  $id_usuario: String! 
  $id_encuesta: String!
  ) {
  responderEncuesta(
    respuestas: $respuestas,
    id_empresa: $id_empresa,
    id_usuario: $id_usuario,
    id_encuesta: $id_encuesta
  ) {
    id_encuesta
  }
}`;
/*----- ENCUESTA --- */

/*----- FOLOVID --- */
export const CREAR_VACUNA_USUARIO = gql `
mutation CreateDosisVacuna(
  $id_tipo: String!
  $fecha_dosis: String!
  $fecha_siguiente_dosis: String!
  $imagen: String!
  $formato_imagen: String!
  $id_empresa: String!
  $id_usuario: String!
) {
  CreateDosisVacuna(
    id_tipo: $id_tipo,
    fecha_dosis: $fecha_dosis,
    fecha_siguiente_dosis: $fecha_siguiente_dosis,
    imagen: $imagen,
    formato_imagen: $formato_imagen,
    id_empresa: $id_empresa,
    id_usuario: $id_usuario,
  ) {
    id_vacuna
    numero_dosis
    fecha_dosis
    fecha_siguiente_dosis
    url_imagen
    tipo_vacuna {
      id_tipo
      nombre
    }
  }
}`;

export const ELIMINAR_VACUNA_USUARIO = gql `
mutation DeleteVacuna(
  $id_vacuna: String!
  $id_empresa: String!
  $id_usuario: String!
  ) {
  DeleteVacuna(id_vacuna: $id_vacuna, id_empresa: $id_empresa, id_usuario: $id_usuario) {
    id_vacuna
  }
}`;
export const EDITAR_VACUNA_USUARIO = gql `
mutation EditDosisVacuna(
  $id_vacuna: String!
  $id_tipo: String!
  $fecha_dosis: String!
  $fecha_siguiente_dosis: String!
  $id_empresa: String!
  $id_usuario: String!
  $imagen: String!
  $formato_imagen: String!
) {
  EditDosisVacuna(
    id_vacuna: $id_vacuna,
    id_tipo: $id_tipo,
    fecha_dosis: $fecha_dosis,
    fecha_siguiente_dosis: $fecha_siguiente_dosis,
    id_empresa: $id_empresa,
    id_usuario: $id_usuario,
    imagen: $imagen,
    formato_imagen: $formato_imagen
  ) {
    id_vacuna
    numero_dosis
    fecha_dosis
    fecha_siguiente_dosis
    url_imagen
    tipo_vacuna {
      id_tipo
      nombre
    }
  }
}`;

export const REPOTAR_SINTOMA = gql `
mutation ReportarSintomas(
  $respuestas: [RespuestasArr]
  $id_empresa: String!
  $id_usuario: String!
  $temperatura: String!
  $patente: String!
  $id_encuesta: String!
  ) {
  ReportarSintomas(
    respuestas: $respuestas
    id_empresa: $id_empresa
    id_usuario: $id_usuario
    temperatura: $temperatura
    patente: $patente
    id_encuesta: $id_encuesta
  ) {
    id_respuesta
  }
}
`
    /*----- FOLOVID --- */

/*----- BENEFICIO --- */
export const CREA_SOLICITUD_BENEFICIO = gql `
mutation GuardarSolicitudUsuarioObjeto(
  $id_empresa: String!
  $id_tipo_solicitud: String!
  $id_usuario: String!
  $detalle_solicitud: [GuardarDetalleSol]
) 
{
  GuardarSolicitudUsuarioObjeto(id_empresa: $id_empresa, id_tipo_solicitud: $id_tipo_solicitud, id_usuario: $id_usuario,
  detalle_solicitud: $detalle_solicitud) 
  {
    id_solicitud,
      codigo_solicitud,
      descripcion,
      fecha_creacion,
      estado_solicitud {
        id_estado_solicitud,
        nombre,
        color
      }
      detalle_solicitud {
        id_solicitud_detalle,
        cantidad_solicitada,
        cantidad_entregada
      },
      tipo_solicitud {
        id_tipo,
        nombre_solicitud,
        descripcion,
        datos_formulario {
          id_formulario,
          nombre,
          is_admin,
          condicion,
          con_valor_predeterminado,
          tipo_dato,
          datos_selector_producto {
            id_inventario,
            nombre,
            con_limite,
            con_detalle,
            cantidad_actual,
            cantidad_inicial,
            limite_cantidad
          }
          datos_selector_empresa {
            id_dato_selector,
            nombre,
            descripcion
          },
          datos_selector_inventario {
            id_detalle,
            nombre_detalle,
            codigo_detalle,
            tipo_detalle
          }
          informacion_usuario
        },
      }
    }
}`;
/*----- BENEFICIO --- */

/* CHAT */
export const CREAR_CHAT_INDIVIDUAL = gql `
mutation crearMensajeChatIndividual(
  $id_destinatario: String!
  $id_empresa: String!
  $id_usuario: String!
  $mensaje: String!
) {
  crearMensajeChatIndividual(
    id_destinatario: $id_destinatario
    id_empresa_fk: $id_empresa
    id_usuario: $id_usuario 
    mensaje: $mensaje
  ) {
    id_chat
    mensajes {
      id_chat_mensaje
      mensaje
      visto_mensaje
      fecha_creacion
      id_destinatario
      id_remitente
    }
  }
}`;


export const ENVIAR_MENSAJE_CHAT_INDIVIDUAL = gql `
mutation enviarMensajeChat(
  $id_usuario: String!
  $id_destinatario: String!
  $id_empresa: String!
  $id_chat: String!
  $mensaje: String!
) {
  enviarMensajeChat(
    id_destinatario: $id_destinatario
    id_usuario: $id_usuario 
    id_empresa_fk: $id_empresa
    id_chat: $id_chat
    mensaje: $mensaje
  ) {
    id_chat_mensaje
    mensaje
    visto_mensaje
    id_chat_fk
    id_estado_fk
    fecha_creacion
    id_destinatario
    id_remitente
  }
}`;

export const ENVIAR_MENSAJE_CHAT_GRUPO = gql `
mutation enviarMensajeGrupo(
  $id_usuario: String!
  $mensaje: String!
  $id_empresa: String!
  $id_grupo: String!
) {
  enviarMensajeGrupo(
    id_usuario: $id_usuario 
    id_empresa_fk: $id_empresa
    id_grupo: $id_grupo
    mensaje: $mensaje
  ) {
    id_chat_grupo_mensaje
    id_grupo_fk
    id_usuario_grupo_fk
    id_estado_fk
    mensaje
    fecha_creacion
    remitente {
      id_usuario
      primer_nombre
      apellido_paterno
    }
  }
}`;


export const INSERTAR_VISTO_INDIVIDUAL = gql `
mutation insertarVistoIndividual(
  $id_chat: String!
  $id_empresa: String!
  $id_usuario: String!
) {
  insertarVistoIndividual(
    id_chat: $id_chat
  	id_empresa_fk: $id_empresa
    id_usuario: $id_usuario
  ) {
    visto_mensaje
  }
}`;

export const INSERTAR_VISTO_GRUPAL = gql `
mutation insertarVistoGrupal(
  $id_grupo: String!
  $id_empresa: String!
  $id_usuario: String!
) {
  insertarVistoGrupal(
    id_grupo: $id_grupo
  	id_empresa_fk: $id_empresa
    id_usuario: $id_usuario
  ) {
    visto
  }
}`;


export const AGREGAR_FAVORITO_CHAT = gql `
mutation agregarFavorito(
  $id_empresa: String!
  $id_usuario: String!
  $id_chat: String!
  $id_favorito: String!
) {
  agregarFavorito(
    id_empresa_fk: $id_empresa
    id_usuario: $id_usuario
    id_chat: $id_chat
    id_favorito: $id_favorito
  ) {
    id_chat_favorito
    id_estado_favorito_fk
    id_chat_fk
  }
}`;

export const ELIMINAR_FAVORITO_CHAT = gql `
mutation eliminarFavorito(
  $id_empresa: String!
  $id_usuario: String!
  $id_chat: String!
  $id_favorito: String!
) {
  eliminarFavorito(
    id_empresa_fk: $id_empresa
    id_usuario: $id_usuario
    id_chat: $id_chat
    id_favorito: $id_favorito
  ) {
    id_chat_favorito
    id_estado_favorito_fk
    id_chat_fk
  }
}`;

export const ELIMINAR_CHAT_INDIVIDUAL = gql `
mutation eliminarChat(
  $id_usuario: String!
  $id_chat: String!
  $id_empresa: String!
) {
  eliminarChat(
    id_usuario: $id_usuario,
    id_chat: $id_chat,
    id_empresa_fk: $id_empresa
  ) {
    id_chat
    id_estado_fk
    id_empresa_fk
    fecha_creacion
    fecha_modificacion
    is_favorito
  }
}`

/*----- NOTIFICACIONES --- */
export const DELETE_NOTIFICACIONES = gql `
mutation borrarNotificacionLista(
  $id_empresa: String!
  $id_usuario: String!
  $id_notificaciones: [String]!
)
{
  borrarNotificacionLista(id_empresa: $id_empresa, id_usuario: $id_usuario, id_notificaciones: $id_notificaciones) 
  {
    id_notificaciones_fk
  }
}`;

export const VISTO_NOTIFICACIONES = gql `
mutation insertarVistoNotificacion(
  $id_empresa: String!
  $id_usuario: String!
  $id_notificaciones: [String]!
){
  insertarVistoNotificacion(id_empresa: $id_empresa, id_usuario: $id_usuario, id_notificaciones: $id_notificaciones) {
    id_notificaciones_fk
}
}`;


/*----- NOTIFICACIONES --- */

/* ----- VISTOS GENERALES --------- */

export const INSERT_VISTO_GENERAL = gql `
mutation insertarVistoGeneral(
  $id_modulo: String!
  $id_empresa: String!
  $id_usuario: String!
  $id_objeto: String!
) {
  insertarVistoGeneral(
    id_modulo: $id_modulo
  	id_empresa: $id_empresa
    id_usuario: $id_usuario
    id_objeto: $id_objeto
  ) {
    usuario {
      id_usuario
    }
  }
}`;

/* ----- VISTOS GENERALES --------- */